import * as semver from 'semver'

export const checkRuntimeVersion = (runtimeVersion: Nullable<string>, latestRuntimeVersion: string) => {
  const isValidRuntimeVersion = (version: Nullable<string>): version is string => {
    return version !== null && Boolean(semver.valid(version))
  }

  return isValidRuntimeVersion(runtimeVersion) && semver.gt(runtimeVersion, latestRuntimeVersion)
}
